import script from "./SportSectionEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./SportSectionEdit.vue?vue&type=script&setup=true&lang=js"

import "./SportSectionEdit.vue?vue&type=style&index=0&id=c85aed4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c85aed4e"]])

export default __exports__